<div
  #moreButton
  class="item-conversation-window"
  [ngClass]="{
    'in-focus': isInFocus(),
  }"
  data-testid="conversation-item"
  [attr.data-conversation-id]="conversationId()">
  @let activeConversation = conversation();
  @if (activeConversation) {
    @if (!isCollapsed()) {
      <div class="item-chat">
        <shared-conversation-header
          class="item-conversation-header"
          [conversation]="conversation()"
          [conversationType]="
            conversationTypes() | findBy: 'id' : activeConversation.conversationTypeId
          "
          [ngClass]="{
            'active-chat': isActive(),
          }" />
        @if (showParticipantList()) {
          <shared-participant-list
            [participants]="activeConversation.participants ?? []"
            [user]="user()"
            (menuClicked)="menuClicked($event)" />
        }
        <div class="conversation-wrapper">
          @let participant = activeConversation.participants ?? [] | findBy: 'userId' : user()?.id;
          <shared-conversation
            [conversationLockNote]="conversationLockedNote()"
            [conversationId]="conversationId()"
            [templates]="templates()"
            [conversationParticipants]="activeConversation.participants ?? []"
            [errors]="errors()"
            [files]="activeConversation.files"
            [isConversationLocked]="isConversationLocked()"
            [isConversationArchived]="activeConversation.archived"
            [loading]="activeConversation.messageSending"
            [messageAppendLoading]="messageAppendLoading()"
            [messageIdsWithError]="messageIdsWithError()"
            [messageInputController]="activeConversation.messageInput"
            [messagePrependLoading]="messagePrependLoading()"
            [messages]="messages()"
            [nextMessageSourceId]="activeConversation.messageSourceId"
            [otherTypingParticipants]="otherTypingParticipants()"
            [participant]="participant"
            [senderType]="senderType"
            [conversationAppType]="conversationAppType()"
            [userId]="user()?.id"
            [sharedUserDisplayName]="sharedUserDisplayName()"
            [windowService]="windowService"
            [userIsNotParticipant]="userIsNotParticipant()"
            (assetClicked)="handleAssetClick($event)"
            (filesChange)="handleFilesChange($event)"
            (fetchForNewMessages)="fetchForNewMessages()"
            (isTyping)="sendIsTypingEvent($event)"
            (messagesLimitChanged)="handleMessageLimitChange($event, conversationId())"
            (joinConversation)="addUserAsParticipant()"
            (messageButtonClicked)="handleMessageButtonClick($event)"
            (messageRead)="messageRead.emit($event)"
            (refreshMessages)="refreshMessages()"
            (resendMessage)="handleResendMessage($event)"
            (scrolled)="handleDownScroll()"
            (scrolledToBottom)="handleScrolledToBottom($event)"
            (scrolledUp)="handleUpScroll()"
            (sendMessage)="handleSendMessage($event)"
            (sendOpenLiveTrackerEvent)="handleIsOpenEvent($event)"
            (unlockAction)="unlockConversation($event)" />
        </div>
      </div>
    }
    <shared-conversation-item-sidebar
      class="item-sidebar"
      [label]="'Chat'"
      [userId]="user()?.id"
      [isActive]="isActive()"
      [isCloseable]="isCloseable()"
      [isDraggable]="isDraggable()"
      [activeIcon]="showParticipantList() ? sidebarButtonTypeEnum.Participants : null"
      [conversationData]="activeConversation"
      [conversationId]="conversationId()"
      [isConversationArchived]="activeConversation.archived"
      (toggleParticipantList)="toggleParticipantList()" />
  }
</div>
